export const optionalRelationMatches = (value: string, expected: string) =>
  !value || value === expected;
